module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Text-75-a2576da01e63a75b0a98f8efac575586.woff";